import React from "react";

const MedicalPartnerListTcSwitch = ({ rowId, item, checked, disabled, title, onTcSwitchChange }) => (
  <div className="custom-control custom-switch" title={title || undefined}>
    <input
      type="checkbox"
      className="custom-control-input"
      id={`partner-list-tc-${rowId}`}
      checked={checked}
      disabled={disabled}
      onChange={(e) => onTcSwitchChange(item, e.target.checked)}
      onClick={(e) => e.stopPropagation()}
    />
    <label className="custom-control-label" htmlFor={`partner-list-tc-${rowId}`}>
      <span className="sr-only">Partner teleconsultation approved</span>
    </label>
  </div>
);

export default MedicalPartnerListTcSwitch;
